module.exports = __webpack_public_path__ + "static/img/f-msg.110a7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f-msg.png
// module id = M2qn
// module chunks = 1